/* Local-only reflection UI. No requests, storage, or analytics events. */
(() => {
  if (window.THQTrainerAnswers) { window.THQTrainerAnswers.refresh(); return; }
  const instances = new Map();
  let sequence = 0;
  function mount(root) {
    const dialog = root.querySelector('dialog');
    const stage = root.querySelector('[data-stage]');
    if (!dialog || !stage) return;
    const form = document.createElement('form');
    form.className = 'thq-answer';
    form.setAttribute('aria-label', 'Trainer tip answer');
    const label = document.createElement('label');
    label.textContent = 'Your Answer Here:';
    const input = document.createElement('textarea');
    input.id = `thq-answer-${++sequence}`;
    input.rows = 4;
    input.required = true;
    input.autocomplete = 'off';
    // No name: the response is never part of a page/form submission.
    label.htmlFor = input.id;
    const button = document.createElement('button');
    button.type = 'submit';
    button.className = 'thq-answer__submit';
    const status = document.createElement('span');
    status.className = 'thq-answer__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    form.append(label, input, button, status);
    const description = root.querySelector('[data-modal-description]');
    if (description && dialog.contains(description)) description.after(form);
    else stage.after(form);
    function reset() {
      input.value = '';
      input.readOnly = false;
      input.setCustomValidity('');
      button.disabled = false;
      button.textContent = 'Submit';
      button.classList.remove('is-complete');
      status.textContent = '';
    }
    function submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      input.setCustomValidity(input.value.trim() ? '' : 'Please enter an answer.');
      if (!input.reportValidity()) return;
      input.readOnly = true;
      button.textContent = '✓ Completed!';
      button.classList.add('is-complete');
      button.disabled = true;
      status.textContent = 'Completed!';
    }
    const clearValidity = () => input.setCustomValidity('');
    form.addEventListener('submit', submit);
    input.addEventListener('input', clearValidity);
    dialog.addEventListener('close', reset);
    // The existing player replaces the iframe on open/close. Reset also when
    // switching videos without closing and when the dialog open attribute changes.
    const observer = new MutationObserver(reset);
    observer.observe(stage, {childList:true});
    observer.observe(dialog, {attributes:true, attributeFilter:['open']});
    reset();
    instances.set(root, {destroy() {
      observer.disconnect();
      dialog.removeEventListener('close', reset);
      form.removeEventListener('submit', submit);
      input.removeEventListener('input', clearValidity);
      reset();
      form.remove();
    }});
  }
  function refresh() {
    const enabled = Boolean(document.querySelector('[data-thq-trainer-answers]'));
    for (const [root, instance] of instances) {
      if (!enabled || !root.isConnected) { instance.destroy(); instances.delete(root); }
    }
    if (enabled) document.querySelectorAll('[data-thq-library]').forEach(root => {
      if (!instances.has(root)) mount(root);
    });
  }
  window.THQTrainerAnswers = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => setTimeout(refresh, 0));
  document.addEventListener('shopify:section:reorder', refresh);
  window.addEventListener('pagehide', () => {
    for (const instance of instances.values()) instance.destroy();
    instances.clear();
  });
  window.addEventListener('pageshow', refresh);
})();
